import { useState, useEffect, useCallback } from 'react'

const cache = new Map<string, { content: string; expiry: number }>()
const TTL = 5 * 60 * 1000

export function useDoc(section: string | null) {
  const [content, setContent] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchDoc = useCallback(async () => {
    if (!section) return

    const cached = cache.get(section)
    if (cached && cached.expiry > Date.now()) {
      setContent(cached.content)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const res = await fetch(`/docs/${section}.md`)
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const text = await res.text()
      cache.set(section, { content: text, expiry: Date.now() + TTL })
      setContent(text)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load')
      setContent('')
    } finally {
      setLoading(false)
    }
  }, [section])

  useEffect(() => {
    fetchDoc()
  }, [fetchDoc])

  return { content, loading, error, reload: fetchDoc }
}
